module.exports = __webpack_public_path__ + "img/icono facebook.1877b9ec.png";